import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { TASK_APPROVAL_CACHE_KEY, TASK_CACHE_KEY, TASK_BY_ID_CACHE_KEY, TASKS_CACHE_KEY } from "@/src/lib/data-fetchers/tasks-fetchers";
import type { ResolveAthenaCoverage } from "@/src/models/athena-coverage-resolution";
import { getAthenaCoverageResolution, submitAthenaCoverageResolution } from "@/src/requests/athena-coverage-resolution";
export function useAthenaCoverageResolution(taskId, enabled) {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== taskId) {
    t0 = ["athena-coverage-resolution", taskId];
    t1 = () => getAthenaCoverageResolution(taskId);
    $[0] = taskId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== enabled || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      enabled,
      staleTime: 0,
      refetchOnWindowFocus: false
    };
    $[3] = enabled;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
}
export function useResolveAthenaCoverage(taskId) {
  const $ = _c(7);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== taskId) {
    t0 = input => submitAthenaCoverageResolution(taskId, input);
    $[0] = taskId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== queryClient) {
    t1 = async () => {
      await Promise.all([TASK_APPROVAL_CACHE_KEY, TASK_CACHE_KEY, TASK_BY_ID_CACHE_KEY, TASKS_CACHE_KEY].map(key => queryClient.invalidateQueries({
        queryKey: [key]
      })));
    };
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useMutation(t2);
}